import { AttributeRangeDefinition } from '../Validation'
import { NamedFields } from '../core'
import { EncodingType, EncodingTypeOf } from './EncodingTypes'

/** Putative IoTV standard device control types, required as consumed in UI */

export type DeviceControlRequestBaseType = {
  downlinkRandom: number
}

export type VERIFIED_CONTROL = {
  verify: 0x5a
}

export interface GenericConfigType {
  [K: string]: number
}

export type DeviceConfigType = {
  ADR: number
  DR: number
  Activity: number
  Condition: number
  Alert: number
}

export const DeviceConfigTypeFields: EncodingTypeOf<DeviceConfigType> = {
  ADR: EncodingType.U8Int,
  DR: EncodingType.U8Int,
  Activity: EncodingType.U16IntLE,
  Condition: EncodingType.U16IntLE,
  Alert: EncodingType.U16IntLE,
}

export type DeviceOptionsMap = {
  GPS_AV: boolean
  APP_MSG_BATT: boolean
  USE_NETWORK_TIME: boolean
  USE_GPS_EXTINT: boolean
  GPS_NO_SKIP: boolean
  DEBUG: boolean
}

export type DeviceShutdownRequest = {
  deviceShutdown: boolean
}

export type GeneralDeviceControlRequestType = DeviceControlRequestBaseType & {
  clearErrorCodes: boolean
  reboot: boolean
  sendConfig: boolean
  accelerometerThreshold: number
  restoreDefaults: boolean
  optionsValues: DeviceOptionsMap | undefined // fix under scrutiny
  appCycleTime: number
  sysCycleTime: number
  adr: 0 | 1
  dr: 0 | 1 | 2
  downlinkDeviceShutdown: DeviceShutdownRequest
  downlinkRestore: NamedFields<VERIFIED_CONTROL>
  downlinkReboot: NamedFields<VERIFIED_CONTROL>
  downlinkReqOptions: null
  downlinkSetOptions: DeviceOptionsMap
}

export const GeneralDownlinkPayloadAttributeRangeLimits: AttributeRangeDefinition<GeneralDeviceControlRequestType> = {
  adr: { attributeType: 'number', range: { min: 0, max: 1 } },
  appCycleTime: { attributeType: 'number', range: { min: 1, max: 1440 } },

  dr: { attributeType: 'number', range: { min: 0, max: 2 } },
  sysCycleTime: { attributeType: 'number', range: { min: 60, max: 10800 } },

  sendConfig: {
    attributeType: 'number',
    range: {
      min: 0,
      max: 0,
    },
  },
  accelerometerThreshold: {
    attributeType: 'number',
    range: {
      min: 0,
      max: 0,
    },
  },

  clearErrorCodes: {
    attributeType: 'number',
    range: {
      min: 0,
      max: 0,
    },
  },
  restoreDefaults: {
    attributeType: 'number',
    range: {
      min: 0,
      max: 0,
    },
  },
  reboot: {
    attributeType: 'number',
    range: {
      min: 0,
      max: 0,
    },
  },
  downlinkDeviceShutdown: {
    attributeType: 'boolean',
  },
  downlinkRandom: {
    attributeType: 'boolean',
  },
  downlinkReboot: {
    attributeType: 'boolean',
  },
  downlinkReqOptions: {
    attributeType: 'boolean',
  },
  downlinkRestore: {
    attributeType: 'boolean',
  },
  downlinkSetOptions: {
    attributeType: 'boolean',
  },
  optionsValues: {
    attributeType: 'array',
  },
}
